export const SET_NEW_Dashboard = "SET_NEW_Dashboard";
export const UPDATE_NEW_Dashboard = "UPDATE_NEW_Dashboard";